// Geo lookup utility to convert stop names to coordinates
// This is a mapping of known bus stops to their coordinates

export const STOP_COORDINATES = {
  // ============================================
  // NAIROBI - Shopping Malls & Centers
  // ============================================
  'Yaya Centre': { lat: -1.2966, lng: 36.7836 },
  'Yaya Center': { lat: -1.2966, lng: 36.7836 },
  'Sarit Centre': { lat: -1.2634, lng: 36.8030 },
  'Sarit Center': { lat: -1.2634, lng: 36.8030 },
  'Westgate Mall': { lat: -1.2621, lng: 36.8040 },
  'Westlands Mall': { lat: -1.2921, lng: 36.8219 },
  'Village Market': { lat: -1.2297, lng: 36.8047 },
  'The Hub Karen': { lat: -1.3197, lng: 36.7081 },
  'Karen Hub': { lat: -1.3197, lng: 36.7081 },
  'Karen Shopping Center': { lat: -1.3197, lng: 36.7081 },
  'Galleria Mall': { lat: -1.3358, lng: 36.7070 },
  'Junction Mall': { lat: -1.3200, lng: 36.7800 },
  'The Junction': { lat: -1.3200, lng: 36.7800 },
  'Prestige Plaza': { lat: -1.2890, lng: 36.7850 },
  'Valley Arcade': { lat: -1.2780, lng: 36.7750 },
  'Lavington Mall': { lat: -1.2697, lng: 36.7581 },
  'Kilimani Mall': { lat: -1.2890, lng: 36.7850 },
  'Parklands Mall': { lat: -1.2634, lng: 36.8581 },
  'Muthaiga Mall': { lat: -1.2434, lng: 36.8281 },
  'Runda Mall': { lat: -1.2134, lng: 36.8081 },
  'Industrial Mall': { lat: -1.3286, lng: 36.8280 },
  'Kileleshwa Mall': { lat: -1.2921, lng: 36.7836 },
  'TRM - Thika Road Mall': { lat: -1.2197, lng: 36.8897 },
  'Thika Road Mall': { lat: -1.2197, lng: 36.8897 },
  'TRM': { lat: -1.2197, lng: 36.8897 },
  'Garden City Mall': { lat: -1.2297, lng: 36.8747 },
  'Garden City': { lat: -1.2297, lng: 36.8747 },
  'Two Rivers Mall': { lat: -1.2097, lng: 36.8047 },
  'Two Rivers': { lat: -1.2097, lng: 36.8047 },
  'Mountain View Mall': { lat: -1.2650, lng: 36.7580 },
  'Mountain View': { lat: -1.2650, lng: 36.7580 },
  'Nextgen Mall': { lat: -1.3100, lng: 36.8080 },
  'Capital Centre': { lat: -1.3050, lng: 36.8200 },
  'Capital Center': { lat: -1.3050, lng: 36.8200 },
  'T-Mall': { lat: -1.2750, lng: 36.7650 },
  'Crossroads Mall': { lat: -1.3150, lng: 36.7100 },
  'Waterfront Mall': { lat: -1.3180, lng: 36.7090 },
  'Greenspan Mall': { lat: -1.2850, lng: 36.8850 },
  'Lifestyle Centre': { lat: -1.2780, lng: 36.8200 },
  
  // ============================================
  // NAIROBI - Flyovers & Landmarks
  // ============================================
  'Kangemi Flyover': { lat: -1.2650, lng: 36.7450 },
  'Kangemi': { lat: -1.2650, lng: 36.7450 },
  'Westlands Flyover': { lat: -1.2673, lng: 36.8030 },
  'Museum Hill': { lat: -1.2750, lng: 36.8150 },
  'Globe Roundabout': { lat: -1.2921, lng: 36.8219 },
  'Uhuru Gardens': { lat: -1.3250, lng: 36.8050 },
  'Nyayo Stadium': { lat: -1.3050, lng: 36.8250 },
  'Kenyatta Stadium': { lat: -1.2864, lng: 36.8172 },
  'Railways Station': { lat: -1.2900, lng: 36.8250 },
  'City Hall': { lat: -1.2850, lng: 36.8200 },
  'Kenyatta Avenue': { lat: -1.2850, lng: 36.8200 },
  'Moi Avenue': { lat: -1.2840, lng: 36.8220 },
  'Tom Mboya Street': { lat: -1.2830, lng: 36.8240 },
  'Waiyaki Way': { lat: -1.2650, lng: 36.7600 },
  'Chiromo': { lat: -1.2700, lng: 36.8100 },
  'Chiromo Bridge': { lat: -1.2700, lng: 36.8100 },
  'Ngong Road Junction': { lat: -1.3000, lng: 36.7700 },
  'ABC Place': { lat: -1.2750, lng: 36.7750 },
  
  // ============================================
  // NAIROBI - Schools & Educational Institutions
  // ============================================
  'Kenya International School': { lat: -1.2921, lng: 36.8219 },
  'International School': { lat: -1.2380, lng: 36.8225 },
  'International School of Kenya': { lat: -1.2297, lng: 36.8047 },
  'ISK': { lat: -1.2297, lng: 36.8047 },
  'Brookhouse School': { lat: -1.2080, lng: 36.8025 },
  'Brookhouse Karen': { lat: -1.3150, lng: 36.7150 },
  'Greenfield Academy': { lat: -1.2864, lng: 36.7780 },
  'Karen Academy': { lat: -1.3197, lng: 36.7081 },
  "St. Mary's School": { lat: -1.2640, lng: 36.7525 },
  'Braeburn School': { lat: -1.2580, lng: 36.7780 },
  'Peponi School': { lat: -1.2100, lng: 36.8100 },
  'Rosslyn Academy': { lat: -1.2200, lng: 36.8050 },
  'Kenton College': { lat: -1.2300, lng: 36.8150 },
  'Hillcrest School': { lat: -1.2150, lng: 36.7900 },
  'Riara Group of Schools': { lat: -1.2697, lng: 36.7581 },
  'Riara Springs': { lat: -1.2697, lng: 36.7581 },
  'Banda School': { lat: -1.2350, lng: 36.7800 },
  'Rusinga School': { lat: -1.2450, lng: 36.7700 },
  'Aga Khan Academy': { lat: -1.2300, lng: 36.8200 },
  'Aga Khan': { lat: -1.2300, lng: 36.8200 },
  'Makini School': { lat: -1.3100, lng: 36.7100 },
  'Consolata School': { lat: -1.2600, lng: 36.8000 },
  'Strathmore School': { lat: -1.3100, lng: 36.7900 },
  
  // ============================================
  // NAIROBI - Neighborhoods & Areas
  // ============================================
  'Westlands': { lat: -1.2673, lng: 36.8030 },
  'Lavington': { lat: -1.2760, lng: 36.7680 },
  'Karen': { lat: -1.3120, lng: 36.7110 },
  'Kilimani': { lat: -1.2890, lng: 36.7850 },
  'Kileleshwa': { lat: -1.2780, lng: 36.7750 },
  'Parklands': { lat: -1.2634, lng: 36.8200 },
  'Runda': { lat: -1.2134, lng: 36.8081 },
  'Muthaiga': { lat: -1.2434, lng: 36.8281 },
  'Gigiri': { lat: -1.2297, lng: 36.8047 },
  'Spring Valley': { lat: -1.2550, lng: 36.7900 },
  'Loresho': { lat: -1.2400, lng: 36.7600 },
  'Kitisuru': { lat: -1.2300, lng: 36.7700 },
  'Nyari': { lat: -1.2200, lng: 36.7800 },
  'Lower Kabete': { lat: -1.2500, lng: 36.7500 },
  'Upper Hill': { lat: -1.2950, lng: 36.8150 },
  'Hurlingham': { lat: -1.2850, lng: 36.7900 },
  'Ngong Road': { lat: -1.3000, lng: 36.7700 },
  'Lang\'ata': { lat: -1.3500, lng: 36.7500 },
  'Langata': { lat: -1.3500, lng: 36.7500 },
  'South B': { lat: -1.3100, lng: 36.8400 },
  'South C': { lat: -1.3200, lng: 36.8300 },
  'Nairobi West': { lat: -1.3150, lng: 36.8150 },
  'Adams Arcade': { lat: -1.3000, lng: 36.7850 },
  'Ngara': { lat: -1.2750, lng: 36.8300 },
  'Eastleigh': { lat: -1.2700, lng: 36.8500 },
  'Buruburu': { lat: -1.2900, lng: 36.8800 },
  'Donholm': { lat: -1.3000, lng: 36.8900 },
  'Umoja': { lat: -1.2850, lng: 36.8950 },
  'Embakasi': { lat: -1.3200, lng: 36.9000 },
  'Kasarani': { lat: -1.2200, lng: 36.9000 },
  'Roysambu': { lat: -1.2100, lng: 36.8800 },
  'Zimmerman': { lat: -1.2050, lng: 36.8900 },
  'Kahawa': { lat: -1.1900, lng: 36.9200 },
  'Ruaka': { lat: -1.2100, lng: 36.7800 },
  'Ridgeways': { lat: -1.2200, lng: 36.8400 },
  'Thome': { lat: -1.2150, lng: 36.8600 },
  'Marurui': { lat: -1.2000, lng: 36.8500 },
  'Highridge': { lat: -1.2550, lng: 36.8100 },
  'Ngong': { lat: -1.3600, lng: 36.6600 },
  'Ongata Rongai': { lat: -1.3950, lng: 36.7450 },
  'Rongai': { lat: -1.3950, lng: 36.7450 },
  'Syokimau': { lat: -1.3700, lng: 36.9200 },
  'Mlolongo': { lat: -1.3900, lng: 36.9400 },
  'Athi River': { lat: -1.4500, lng: 36.9800 },
  'Kitengela': { lat: -1.4700, lng: 36.9600 },
  'Kikuyu': { lat: -1.2500, lng: 36.6600 },
  'Kinoo': { lat: -1.2400, lng: 36.7000 },
  'Kabete': { lat: -1.2550, lng: 36.7300 },
  'Dagoretti': { lat: -1.3000, lng: 36.7400 },
  'Dagoretti Corner': { lat: -1.3000, lng: 36.7400 },
  'Kawangware': { lat: -1.2800, lng: 36.7300 },
  'Satellite': { lat: -1.2750, lng: 36.7200 },
  'Uthiru': { lat: -1.2550, lng: 36.7150 },
  'Banana Hill': { lat: -1.1800, lng: 36.7700 },
  'Rosslyn': { lat: -1.2200, lng: 36.8050 },
  'New Muthaiga': { lat: -1.2350, lng: 36.8350 },
  'Garden Estate': { lat: -1.2100, lng: 36.8700 },
  'Imara Daima': { lat: -1.3300, lng: 36.8850 },
  
  // ============================================
  // NAIROBI - Corporate & Business
  // ============================================
  'ABC Tech Park': { lat: -1.2864, lng: 36.8172 },
  'Corporate Plaza': { lat: -1.3150, lng: 36.7025 },
  'Finance Tower': { lat: -1.2920, lng: 36.7780 },
  'HR Building': { lat: -1.2580, lng: 36.8525 },
  'Operations Center': { lat: -1.3240, lng: 36.8224 },
  'KICC': { lat: -1.2864, lng: 36.8172 },
  'I&M Tower': { lat: -1.2850, lng: 36.8200 },
  'View Park Towers': { lat: -1.2870, lng: 36.8180 },
  'UAP Tower': { lat: -1.2950, lng: 36.8100 },
  'Britam Tower': { lat: -1.2920, lng: 36.8080 },
  'Rahimtulla Tower': { lat: -1.2880, lng: 36.8220 },
  'Delta Tower': { lat: -1.2630, lng: 36.8050 },
  'ABC Place Westlands': { lat: -1.2630, lng: 36.8050 },
  
  // ============================================
  // NAIROBI - Hospitals & Medical
  // ============================================
  'Nairobi Hospital': { lat: -1.2950, lng: 36.8050 },
  'Kenyatta National Hospital': { lat: -1.3000, lng: 36.8100 },
  'KNH': { lat: -1.3000, lng: 36.8100 },
  'Aga Khan Hospital': { lat: -1.2630, lng: 36.8200 },
  'MP Shah Hospital': { lat: -1.2650, lng: 36.8150 },
  'Karen Hospital': { lat: -1.3200, lng: 36.7050 },
  'Gertrudes Hospital': { lat: -1.2700, lng: 36.8050 },
  
  // ============================================
  // NAIROBI - Transport Hubs
  // ============================================
  'JKIA': { lat: -1.3190, lng: 36.9280 },
  'Jomo Kenyatta Airport': { lat: -1.3190, lng: 36.9280 },
  'Wilson Airport': { lat: -1.3210, lng: 36.8150 },
  'Railways': { lat: -1.2900, lng: 36.8250 },
  'Bus Station': { lat: -1.2860, lng: 36.8260 },
  'Country Bus Station': { lat: -1.2860, lng: 36.8260 },
  
  // ============================================
  // Test Stops
  // ============================================
  '(test Stop)- Musa Gitau Road, Nairobi, Kenya': { lat: -1.2656185, lng: 36.763262 },
  'Musa Gitau Road': { lat: -1.2656185, lng: 36.763262 },
  'School Name': { lat: -1.2921, lng: 36.8219 },
  
  // Add more stops as needed
};

/**
 * Normalize a string for comparison (lowercase, remove extra spaces, common substitutions)
 */
const normalizeString = (str) => {
  return str
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ')           // Multiple spaces to single
    .replace(/[''`]/g, "'")         // Normalize apostrophes
    .replace(/centre/g, 'center')   // British to American spelling
    .replace(/\./g, '')             // Remove periods
    .replace(/[,;:]/g, '')          // Remove punctuation
    .replace(/\s*-\s*/g, ' ')       // Normalize dashes
    .replace(/\s*(mall|shopping center|shopping centre)\s*$/i, ''); // Remove common suffixes for matching
};

/**
 * Calculate similarity score between two strings (0-1)
 * Uses a combination of techniques for robust matching
 */
const calculateSimilarity = (str1, str2) => {
  const s1 = normalizeString(str1);
  const s2 = normalizeString(str2);
  
  // Exact match after normalization
  if (s1 === s2) return 1.0;
  
  // Check if one contains the other
  if (s1.includes(s2) || s2.includes(s1)) {
    const longerLen = Math.max(s1.length, s2.length);
    const shorterLen = Math.min(s1.length, s2.length);
    return 0.8 + (0.2 * (shorterLen / longerLen));
  }
  
  // Word-based matching
  const words1 = s1.split(' ').filter(w => w.length > 2);
  const words2 = s2.split(' ').filter(w => w.length > 2);
  
  if (words1.length === 0 || words2.length === 0) return 0;
  
  let matchedWords = 0;
  for (const w1 of words1) {
    for (const w2 of words2) {
      if (w1 === w2 || w1.includes(w2) || w2.includes(w1)) {
        matchedWords++;
        break;
      }
    }
  }
  
  const wordScore = matchedWords / Math.max(words1.length, words2.length);
  
  // Also check Levenshtein-like character overlap for short strings
  let charMatches = 0;
  const s1Chars = s1.split('');
  const s2Set = new Set(s2.split(''));
  for (const c of s1Chars) {
    if (s2Set.has(c)) charMatches++;
  }
  const charScore = charMatches / Math.max(s1.length, s2.length);
  
  
  return Math.max(wordScore * 0.8, charScore * 0.5);
};

/**
 * Look up coordinates for a given stop name with intelligent fuzzy matching
 * First checks local cache, then falls back to Google Maps Geocoding API
 * @param {string} stopName - The name of the stop
 * @returns {object|null} - Object with {lat, lng} or null if not found
 */
export const getCoordinatesForStop = (stopName) => {
  if (!stopName || typeof stopName !== 'string') {
    return null;
  }

  const trimmedName = stopName.trim();
  
  // 1. Try exact match first
  if (STOP_COORDINATES[trimmedName]) {
    return STOP_COORDINATES[trimmedName];
  }

  // 2. Try case-insensitive exact match
  const lowerStop = trimmedName.toLowerCase();
  for (const [stopKey, coords] of Object.entries(STOP_COORDINATES)) {
    if (stopKey.toLowerCase() === lowerStop) {
      return coords;
    }
  }

  // 3. Try normalized match (handles "centre" vs "center", punctuation, etc.)
  const normalizedInput = normalizeString(trimmedName);
  for (const [stopKey, coords] of Object.entries(STOP_COORDINATES)) {
    if (normalizeString(stopKey) === normalizedInput) {
      return coords;
    }
  }

  // 4. Fuzzy matching with similarity scoring
  let bestMatch = null;
  let bestScore = 0;
  const SIMILARITY_THRESHOLD = 0.6; // Minimum score to accept a match

  for (const [stopKey, coords] of Object.entries(STOP_COORDINATES)) {
    const score = calculateSimilarity(trimmedName, stopKey);
    if (score > bestScore && score >= SIMILARITY_THRESHOLD) {
      bestScore = score;
      bestMatch = coords;
    }
  }

  if (bestMatch) {
    console.log(`📍 Fuzzy matched "${trimmedName}" with score ${bestScore.toFixed(2)}`);
    return bestMatch;
  }

  // 5. Try partial word match as last resort
  const inputWords = normalizedInput.split(' ').filter(w => w.length > 3);
  for (const word of inputWords) {
    for (const [stopKey, coords] of Object.entries(STOP_COORDINATES)) {
      const stopKeyNorm = normalizeString(stopKey);
      // Check if any significant word from input matches a key word
      if (stopKeyNorm.split(' ').some(keyWord => 
        keyWord.length > 3 && (keyWord.includes(word) || word.includes(keyWord))
      )) {
        console.log(`📍 Word-matched "${trimmedName}" to "${stopKey}" via word "${word}"`);
        return coords;
      }
    }
  }

  // Not found in local cache - will need async Google Maps lookup
  return null;
};

// Google Maps API key (same as used in Address.js)
const GOOGLE_MAPS_API_KEY = 'AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs';

// Cache for pending Google Maps lookups to avoid duplicate requests
const pendingLookups = new Map();

/**
 * Look up coordinates using Google Maps Geocoding API
 * @param {string} locationName - The location name to geocode
 * @param {string} region - Optional region bias (default: 'ke' for Kenya)
 * @returns {Promise<{lat: number, lng: number}|null>} - Coordinates or null if not found
 */
export const geocodeWithGoogleMaps = async (locationName, region = 'ke') => {
  if (!locationName || typeof locationName !== 'string') {
    return null;
  }

  const trimmedName = locationName.trim();
  
  // Check if we already have a pending request for this location
  if (pendingLookups.has(trimmedName)) {
    return pendingLookups.get(trimmedName);
  }

  // Add ", Kenya" or ", Nairobi, Kenya" if not already present to improve accuracy
  let searchQuery = trimmedName;
  const lowerName = trimmedName.toLowerCase();
  if (!lowerName.includes('kenya') && !lowerName.includes('nairobi')) {
    searchQuery = `${trimmedName}, Nairobi, Kenya`;
  } else if (!lowerName.includes('kenya')) {
    searchQuery = `${trimmedName}, Kenya`;
  }

  const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(searchQuery)}&region=${region}&key=${GOOGLE_MAPS_API_KEY}`;

  const lookupPromise = (async () => {
    try {
      console.log(`🌍 Google Maps lookup for: "${searchQuery}"`);
      
      const response = await fetch(geocodeUrl);
      const data = await response.json();

      if (data.status === 'OK' && data.results && data.results.length > 0) {
        const location = data.results[0].geometry.location;
        const coords = {
          lat: location.lat,
          lng: location.lng
        };

        // Cache the result for future lookups
        STOP_COORDINATES[trimmedName] = coords;
        console.log(`✅ Google Maps found "${trimmedName}" at ${coords.lat}, ${coords.lng}`);
        
        return coords;
      } else if (data.status === 'ZERO_RESULTS') {
        console.log(`❌ Google Maps: No results for "${searchQuery}"`);
        return null;
      } else {
        console.error(`❌ Google Maps API error: ${data.status}`, data.error_message);
        return null;
      }
    } catch (error) {
      console.error(`❌ Google Maps lookup failed for "${trimmedName}":`, error);
      return null;
    } finally {
      // Remove from pending lookups
      pendingLookups.delete(trimmedName);
    }
  })();

  // Store the pending promise
  pendingLookups.set(trimmedName, lookupPromise);

  return lookupPromise;
};

/**
 * Async version of getCoordinatesForStop that uses Google Maps API first
 * First tries Google Maps Geocoding API, then falls back to local cache if API fails
 * @param {string} stopName - The name of the stop
 * @returns {Promise<{lat: number, lng: number}|null>} - Coordinates or null if not found
 */
export const getCoordinatesForStopAsync = async (stopName) => {
  // First try Google Maps API
  console.log(`🌍 Looking up "${stopName}" via Google Maps...`);
  const googleResult = await geocodeWithGoogleMaps(stopName);
  if (googleResult) {
    return googleResult;
  }

  // If Google Maps fails, fall back to local cache
  console.log(`📍 Google Maps failed for "${stopName}", trying local cache...`);
  const localResult = getCoordinatesForStop(stopName);
  return localResult;
};

/**
 * Batch lookup coordinates for multiple locations
 * Uses Google Maps API first, falls back to local cache if API fails
 * @param {string[]} locationNames - Array of location names to look up
 * @returns {Promise<Map<string, {lat: number, lng: number}|null>>} - Map of location names to coordinates
 */
export const batchGetCoordinates = async (locationNames) => {
  const results = new Map();
  const validNames = [];

  for (const name of locationNames) {
    if (!name || typeof name !== 'string') {
      results.set(name, null);
      continue;
    }
    validNames.push(name.trim());
  }

  // Perform Google Maps lookups in parallel (with concurrency limit)
  if (validNames.length > 0) {
    console.log(`🌍 Performing ${validNames.length} Google Maps lookups...`);
    
    // Limit concurrent requests to avoid rate limiting
    const BATCH_SIZE = 5;
    for (let i = 0; i < validNames.length; i += BATCH_SIZE) {
      const batch = validNames.slice(i, i + BATCH_SIZE);
      const batchResults = await Promise.all(
        batch.map(async (name) => {
          // Try Google Maps first
          const googleResult = await geocodeWithGoogleMaps(name);
          if (googleResult) {
            return googleResult;
          }
          // Fall back to local cache
          console.log(`📍 Google Maps failed for "${name}", trying local cache...`);
          return getCoordinatesForStop(name);
        })
      );
      
      batch.forEach((name, index) => {
        results.set(name, batchResults[index]);
      });
      
      // Small delay between batches to avoid rate limiting
      if (i + BATCH_SIZE < validNames.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
  }

  return results;
};

/**
 * Get all available stops
 * @returns {array} - Array of stop names
 */
export const getAllStops = () => {
  return Object.keys(STOP_COORDINATES);
};

/**
 * Add or update a stop in the database
 * @param {string} stopName - The name of the stop
 * @param {object} coordinates - {lat, lng}
 */
export const addStop = (stopName, coordinates) => {
  if (!stopName || !coordinates || coordinates.lat === undefined || coordinates.lng === undefined) {
    throw new Error('Invalid stop name or coordinates');
  }
  STOP_COORDINATES[stopName.trim()] = {
    lat: parseFloat(coordinates.lat),
    lng: parseFloat(coordinates.lng)
  };
};

/**
 * Bulk add stops
 * @param {object} stopsMap - Object with stop names as keys and {lat, lng} as values
 */
export const addStops = (stopsMap) => {
  Object.entries(stopsMap).forEach(([stopName, coords]) => {
    addStop(stopName, coords);
  });
};
